module.exports = __webpack_public_path__ + "media/theme/sample-card__nintendo-8046ceaf.jpg";